import React, { useState } from 'react';
import '../../assets/styles/SuperAdmin/SATheme.css';

export const SA_NAV_ITEMS = [
  { id: 'overview', label: 'Control Center', icon: 'CC' },
  { id: 'notifications', label: 'Notifications', icon: 'NT' },
  { id: 'roles', label: 'Role Definitions', icon: 'RL' },
  { id: 'matrix', label: 'Permission Matrix', icon: 'PM' },
  { id: 'users', label: 'User Governance', icon: 'UG' },
  { id: 'credentials', label: 'Credentials', icon: 'CR' },
  { id: 'audit', label: 'Audit Trail', icon: 'AT' },
  { id: 'portals', label: 'Portal Health', icon: 'PH' },
  { id: 'security', label: 'Security Policies', icon: 'SP' },
];

const SASidebar = ({ page, setPage }) => {
  const [sidebarHover, setSidebarHover] = useState(false);

  return (
    <aside
      onMouseEnter={() => setSidebarHover(true)}
      onMouseLeave={() => setSidebarHover(false)}
      style={{
        width: sidebarHover ? 240 : 72,
        background: 'var(--sa-surface)',
        borderRight: '1px solid var(--sa-border)',
        display: 'flex',
        flexDirection: 'column',
        transition: 'width 0.3s cubic-bezier(.4,0,.2,1)',
        overflow: 'hidden',
        flexShrink: 0,
        zIndex: 10
      }}
    >
      <div style={{ padding: '20px 18px', borderBottom: '1px solid var(--sa-border)', display: 'flex', alignItems: 'center', gap: 12 }}>
        <div style={{
          width: 38,
          height: 38,
          borderRadius: 10,
          flexShrink: 0,
          background: 'linear-gradient(135deg, rgba(229, 57, 53, 0.25), rgba(183, 28, 28, 0.25))',
          border: '2px solid rgba(229, 57, 53, 0.18)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 13,
          fontWeight: 800
        }}>SA</div>
        <div style={{ opacity: sidebarHover ? 1 : 0, transition: 'opacity 0.2s', whiteSpace: 'nowrap' }}>
          <div style={{ fontSize: 14, fontWeight: 800, fontFamily: "'Sora', sans-serif", color: 'var(--sa-text)', lineHeight: 1.2 }}>AMSHRMS</div>
          <div style={{ fontSize: 9, fontWeight: 800, color: 'var(--sa-red)', letterSpacing: '0.14em', textTransform: 'uppercase' }}>SUPER ADMIN PANEL</div>
        </div>
      </div>

      <nav style={{ flex: 1, padding: '12px 10px', display: 'flex', flexDirection: 'column', gap: 2 }}>
        {SA_NAV_ITEMS.map((n) => {
          const active = page === n.id;
          return (
            <div
              key={n.id}
              onClick={() => setPage(n.id)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                padding: '11px 14px',
                borderRadius: 10,
                cursor: 'pointer',
                position: 'relative',
                background: active ? 'rgba(229, 57, 53, 0.08)' : 'transparent',
                transition: 'all 0.15s'
              }}
              onMouseEnter={(e) => { if (!active) e.currentTarget.style.background = 'var(--sa-card-hover)'; }}
              onMouseLeave={(e) => { if (!active) e.currentTarget.style.background = 'transparent'; }}
            >
              {active && <div style={{ position: 'absolute', left: 0, top: '50%', transform: 'translateY(-50%)', width: 3, height: 22, borderRadius: 4, background: 'var(--sa-red)' }} />}
              <span style={{ fontSize: 12, width: 24, textAlign: 'center', flexShrink: 0, fontWeight: 800 }}>{n.icon}</span>
              <span style={{
                fontSize: 13,
                fontWeight: active ? 700 : 500,
                color: active ? 'var(--sa-red)' : 'var(--sa-muted)',
                opacity: sidebarHover ? 1 : 0,
                transition: 'opacity 0.15s',
                whiteSpace: 'nowrap'
              }}>{n.label}</span>
            </div>
          );
        })}
      </nav>

      <div style={{ padding: '16px 14px', borderTop: '1px solid var(--sa-border)', display: 'flex', alignItems: 'center', gap: 10 }}>
        <div style={{ width: 36, height: 36, borderRadius: 10, background: 'linear-gradient(135deg, var(--sa-accent), #B71C1C)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 800, color: '#fff', flexShrink: 0 }}>SA</div>
        <div style={{ opacity: sidebarHover ? 1 : 0, transition: 'opacity 0.15s', whiteSpace: 'nowrap' }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--sa-text)' }}>Super Admin</div>
          <div style={{ fontSize: 10, color: 'var(--sa-red)', fontWeight: 600 }}>Authenticated - Full Access</div>
        </div>
      </div>
    </aside>
  );
};

export default SASidebar;
